<div class="bg-white rounded-lg shadow-sm border border-gray-200 p-5 mb-4">
  <div class="flex items-center justify-between mb-3">
    <h3 class="text-lg font-semibold text-dark">Propuestas de examen</h3>
    <button *ngIf="isTeacher && !showForm" (click)="showForm = true"
      class="text-sm px-3 py-1.5 rounded-lg bg-primary text-white hover:bg-primary-600">
      Proponer alumno
    </button>
  </div>

  <!-- Form del profesor -->
  <div *ngIf="isTeacher && showForm" class="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div class="flex flex-col">
        <label class="text-xs text-gray-600 mb-1">Alumno</label>
        <select [(ngModel)]="selectedStudentId" (ngModelChange)="onStudentChange()"
          class="border border-gray-300 rounded-lg px-3 py-2 text-sm">
          <option [ngValue]="null" disabled>Selecciona alumno</option>
          <option *ngFor="let s of students" [ngValue]="s.id">{{ fullName(s) }}</option>
        </select>
      </div>
      <div class="flex flex-col">
        <label class="text-xs text-gray-600 mb-1">Carnet</label>
        <select [(ngModel)]="selectedLicenseId" [disabled]="!selectedStudentId"
          class="border border-gray-300 rounded-lg px-3 py-2 text-sm disabled:bg-gray-100">
          <option [ngValue]="null" disabled>Selecciona carnet</option>
          <option *ngFor="let l of licenses" [ngValue]="l.id">{{ l.name }}</option>
        </select>
      </div>
    </div>
    <div class="flex flex-col mt-3">
      <label class="text-xs text-gray-600 mb-1">Nota (opcional)</label>
      <textarea [(ngModel)]="note" rows="2" class="border border-gray-300 rounded-lg px-3 py-2 text-sm"></textarea>
    </div>
    <div class="flex justify-end gap-2 mt-3">
      <button (click)="resetForm()" class="text-sm px-3 py-1.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100">Cancelar</button>
      <button (click)="propose()" [disabled]="saving"
        class="text-sm px-4 py-1.5 rounded-lg bg-primary text-white hover:bg-primary-600 disabled:opacity-50">
        Enviar propuesta
      </button>
    </div>
  </div>

  <p *ngIf="loading" class="text-sm text-gray-400">Cargando…</p>
  <p *ngIf="!loading && !proposals.length" class="text-sm text-gray-400">No hay propuestas.</p>

  <!-- Lista de propuestas -->
  <div class="divide-y divide-gray-100">
    <div *ngFor="let p of proposals" class="flex items-center justify-between py-3 gap-3">
      <div class="min-w-0">
        <p class="text-sm font-medium text-dark truncate">
          {{ fullName(p.user) }}
          <span *ngIf="p.license" class="text-xs text-gray-500">· {{ p.license.name }}</span>
        </p>
        <p class="text-xs text-gray-500">
          Propuesto por {{ p.teacher?.name || 'profesor' }}
          <span *ngIf="p.note">· {{ p.note }}</span>
        </p>
      </div>
      <div class="flex items-center gap-2 flex-shrink-0">
        <span class="px-2 py-0.5 rounded-full text-xs font-semibold"
          [ngClass]="{
            'bg-amber-100 text-amber-700': p.status === 'pending',
            'bg-green-100 text-green-700': p.status === 'accepted',
            'bg-red-100 text-red-700': p.status === 'rejected'
          }">
          {{ statusLabel(p.status) }}
        </span>

        <!-- Admin: aceptar / rechazar -->
        <ng-container *ngIf="isAdmin && p.status === 'pending'">
          <button (click)="accept(p)" class="text-xs px-2.5 py-1 rounded-lg bg-green-600 text-white hover:bg-green-700">Aceptar</button>
          <button (click)="reject(p)" class="text-xs px-2.5 py-1 rounded-lg bg-red-600 text-white hover:bg-red-700">Rechazar</button>
        </ng-container>

        <!-- Profesor: cancelar su propuesta pendiente -->
        <button *ngIf="isTeacher && p.status === 'pending'" (click)="cancel(p)"
          class="text-xs px-2.5 py-1 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100">Cancelar</button>
      </div>
    </div>
  </div>
</div>
